module.exports = __webpack_public_path__ + "static/img/bigImg.54e79d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bigImg.png
// module id = 7Ciw
// module chunks = 1